import { render, staticRenderFns } from "./TopCpuTableLines.vue?vue&type=template&id=4ede1d85&"
import script from "./TopCpuTableLines.vue?vue&type=script&lang=js&"
export * from "./TopCpuTableLines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
